import { render, staticRenderFns } from "./HelpHead.vue?vue&type=template&id=077069bd&"
import script from "./HelpHead.vue?vue&type=script&lang=js&"
export * from "./HelpHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports